import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Colors } from '../constants/colors';
import SunIllustration from '../components/SunIllustration';

export default function SplashScreen({ navigation }) {
  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.inner}>
        <View style={styles.spacer} />

        <View style={styles.branding}>
          <SunIllustration size={120} />
          <Text style={styles.title}>Momentum</Text>
          <Text style={styles.tagline}>Take control of your recovery.</Text>
        </View>

        <View style={styles.buttons}>
          <TouchableOpacity
            style={styles.loginButton}
            onPress={() => navigation.navigate('Login')}
          >
            <Text style={styles.loginText}>Log In</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.signupButton}
            onPress={() => navigation.navigate('SignUp')}
          >
            <Text style={styles.signupText}>Sign Up</Text>
          </TouchableOpacity>
        </View>

        <View style={styles.logos}>
          <View style={styles.azarLogo}>
            <Text style={styles.azarText}>AZAR{'\n'}LAB</Text>
          </View>
          <View>
            <Text style={styles.vchName}>Vancouver</Text>
            <Text style={styles.vchSub}>CoastalHealth</Text>
          </View>
        </View>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.splashBot,
  },
  inner: {
    flex: 1,
    paddingHorizontal: 40,
    paddingBottom: 40,
    justifyContent: 'space-between',
    alignItems: 'center',
    // Gradient simulated with overlay — use LinearGradient in production
  },
  spacer: { height: 40 },
  branding: {
    alignItems: 'center',
  },
  title: {
    fontSize: 36,
    fontWeight: '700',
    color: '#fff',
    marginTop: 16,
  },
  tagline: {
    fontSize: 15,
    color: 'rgba(255,255,255,0.85)',
    marginTop: 6,
  },
  buttons: {
    width: '100%',
    gap: 12,
  },
  loginButton: {
    backgroundColor: '#E8C070',
    paddingVertical: 14,
    borderRadius: 25,
    alignItems: 'center',
  },
  loginText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#3A2A10',
  },
  signupButton: {
    borderWidth: 2,
    borderColor: 'rgba(255,255,255,0.6)',
    paddingVertical: 14,
    borderRadius: 25,
    alignItems: 'center',
  },
  signupText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
  },
  logos: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginTop: 24,
  },
  azarLogo: {
    width: 42,
    height: 42,
    borderRadius: 21,
    backgroundColor: 'rgba(255,255,255,0.15)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  azarText: {
    fontSize: 7,
    fontWeight: '700',
    color: '#fff',
    textAlign: 'center',
    lineHeight: 9,
  },
  vchName: {
    fontSize: 15,
    fontWeight: '700',
    color: '#fff',
  },
  vchSub: {
    fontSize: 15,
    fontWeight: '400',
    color: '#fff',
  },
});
